import React from 'react'
 import useSEO from "./useSEO";

const Goodsandservicestax = () => {
  
  useSEO({ 
  title: "Goods and Services Tax (GST) Outsourcing Services | GST Compliance Experts in Hyderabad",
  description: "Simplify GST compliance with our professional GST outsourcing services in Hyderabad. We handle GST registration, GST returns filing, reconciliations, and advisory to ensure accuracy and timely compliance.",
  keywords: "GST outsourcing services,GST Registration, GST compliance Hyderabad, GST return filing, GST registration assistance, GST reconciliation, indirect tax services, GST advisory, GST consultants Hyderabad",
  ogTitle: "GST Outsourcing Services - Trusted Hyderabad Experts",
  ogDescription: "Accurate GST filing, timely compliance, and expert advisory for businesses in Hyderabad.",
  ogImage: "img/gst-outsourcing.png",
  twitterTitle: "GST Outsourcing Services - Trusted Hyderabad Experts",
  twitterDescription: "Simplify your GST compliance process with expert GST outsourcing services in Hyderabad.",
  twitterImage: "img/gst-outsourcing.png"
})
  return (
    <div>

        <>
  <section className="pt-lg-8 pt-xl-9">
    <div className="container position-relative pt-4 pt-lg-0">
      <div className="row align-items-center">
        {/* Title */}
        <div className="col-md-7 col-xl-6 mb-7 mb-md-0">
          <h1 className="mb-4">
            Goods and Services Tax (GST) Outsourcing Services:{" "}
          </h1>
          <p className="mb-4">
            {" "}
            As we have Decades of Experience with Expertise Team to Streamline
            you’re Indirect Taxes to improve Tax Compliances and save your
            penalties and interest cost of your business. No need to worry, let
            us handle it.
          </p>
        </div>
        {/* Image */}
        <div className="col-md-5 ms-auto">
          <img
            src="img/goods-and-services-tax-gst1.png"
            alt="Goods and Services Tax (GST) Outsourcing Services:"
          />
        </div>
      </div>
    </div>
  </section>
  <section className="overflow-hidden pb-0">
    <div className="container">
      <div className="row align-items-center">
        {/* Image */}
        <div className="col-lg-6 text-center position-relative mb-5 mb-lg-0">
          {/* Image */}
          <div className="pe-lg-6 pe-xl-8">
            <img
              src="img/goods-and-services-tax-gst.png"
              alt="Goods and Services Tax (GST) Outsourcing Services:"
            />
          </div>
          {/* Decoration */}
        </div>
        {/* Content */}
        <div className="col-lg-6 ms-auto">
          {/* Title and content */}
          <h2 className="mb-lg-4"> Our GST Services Include:</h2>
          <hr className="my-4 my-lg-5" /> {/* Divider */}
          {/* List */}
          <div className="row">
            <div className="col-sm-12">
              <ul className="list-group list-group-borderless">
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>GST Registration</b>
                </li>
                <p>
                  Assistance with new GST registrations for businesses and
                  professionals.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>GST Return Filing</b>
                </li>
                <p>
                  {" "}
                  Timely and accurate filing of GSTR-1, GSTR-3B, GSTR-9, GSTR-9C
                  &amp; other applicable returns.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>GST Audit &amp; Annual Return Support</b>
                </li>
                <p>
                  Ensuring compliance through reconciliation and preparation of
                  GST annual returns.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>Input Tax Credit (ITC) Management</b>
                </li>
                <p>
                  Accurate tracking and optimization of eligible input credits.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>GST Compliance &amp; Advisory</b>
                </li>
                <p>
                  Ongoing support to stay updated with GST laws, notifications,
                  and circulars.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>GST Refund Assistance</b>
                </li>
                <p>
                  Claiming refunds for excess tax paid, exports, and inverted
                  duty structures.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>E-invoicing &amp; E-way Bill Support</b>
                </li>
                <p>
                  {" "}
                  Implementation and compliance assistance for digital invoicing
                  and transport documentation.
                </p>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>

      
    </div>
  )
}

export default Goodsandservicestax
